export enum ProtocolPartnerType {
	PARTNER_SIGNING_AT = 'partner_signing_at',
	PARTNER__NAME_FULL = 'partner?.name_full',
	PARTNER__VAT_NUMBER = 'partner?.vat_number',
	ID = 'id',
	ACT_DATE = 'act_date',
	FILENAME = 'filename',
	PARTNER_SIGNER = 'partner_signer',
	PARTNER_SIGNER_PHONE = 'partner_signer_phone',
}

export enum ProtocolDsType {
	SUBJECTNAME = 'subjectName',
	THUMBPRINT = 'thumbprint',
}
